<span
  #container
  class="mu-calendar p-calendar"
  [ngClass]="{
    'p-calendar-w-btn': showIcon,
    'p-calendar-timeonly': timeOnly,
    'p-calendar-disabled': disabled,
    'p-focus': focus
  }"
  [ngStyle]="style"
  [class]="styleClass"
>
  <ng-template [ngIf]="!inline">
    <input
      #inputfield
      type="text"
      [attr.id]="inputId"
      [attr.name]="name"
      [attr.required]="required"
      [attr.aria-required]="required"
      [value]="inputFieldValue"
      (focus)="onInputFocus($event)"
      (keydown)="onInputKeydown($event)"
      (click)="onInputClick()"
      (blur)="onInputBlur($event)"
      [readonly]="readonlyInput"
      (input)="onUserInput($event)"
      [ngStyle]="inputStyle"
      [class]="inputStyleClass"
      [placeholder]="placeholder || ''"
      [disabled]="disabled"
      [attr.tabindex]="tabindex"
      [attr.inputmode]="touchUI ? 'off' : null"
      [ngClass]="'p-inputtext p-component'"
      autocomplete="off"
      [attr.aria-labelledby]="ariaLabelledBy"
    /><button
      type="button"
      [attr.aria-label]="iconAriaLabel"
      [icon]="icon"
      pButton
      pRipple
      *ngIf="showIcon"
      (click)="onButtonClick($event, inputfield)"
      class="p-datepicker-trigger"
      [disabled]="disabled"
      tabindex="0"
    ></button>
  </ng-template>
  <div
    #contentWrapper
    [class]="panelStyleClass"
    [ngStyle]="panelStyle"
    [ngClass]="{
      'p-datepicker p-component': true,
      'p-datepicker-inline': inline,
      'p-disabled': disabled,
      'p-datepicker-timeonly': timeOnly,
      'p-datepicker-multiple-month': this.numberOfMonths > 1,
      'p-datepicker-monthpicker': view === 'month',
      'p-datepicker-touch-ui': touchUI
    }"
    [@overlayAnimation]="
      touchUI
        ? { value: 'visibleTouchUI', params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions } }
        : { value: 'visible', params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions } }
    "
    [@.disabled]="inline === true"
    (@overlayAnimation.start)="onOverlayAnimationStart($event)"
    (@overlayAnimation.done)="onOverlayAnimationDone($event)"
    (click)="onOverlayClick($event)"
    *ngIf="inline || overlayVisible"
  >
    <ng-content select="p-header"></ng-content>
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    <ng-container *ngIf="!timeOnly">
      <div class="p-datepicker-group-container">
        <div class="p-datepicker-group" *ngFor="let month of months; let i = index">
          <div class="p-datepicker-header">
            <!-- Header: previous arrow -->
            <button
              type="button"
              (keydown)="onContainerButtonKeydown($event)"
              class="p-datepicker-prev p-link"
              [ngClass]="{
                'p-disabled': disabledPreviousAction()
              }"
              (click)="onPrevButtonClick($event)"
              *ngIf="i === 0"
              pRipple
            >
              <span class="p-datepicker-prev-icon pi pi-chevron-left"></span>
            </button>

            <div class="p-datepicker-title">
              <button
                type="button"
                (click)="switchToMonthView($event)"
                (keydown)="onContainerButtonKeydown($event)"
                *ngIf="currentView === 'date'"
                class="p-datepicker-month p-link"
                [disabled]="switchViewButtonDisabled()"
              >
                {{ getMonthName(month.month) }}
              </button>

              <button
                type="button"
                (click)="switchToYearView($event)"
                (keydown)="onContainerButtonKeydown($event)"
                *ngIf="currentView !== 'year'"
                class="p-datepicker-year p-link"
                [disabled]="switchViewButtonDisabled()"
              >
                {{ getYear(month) }}
              </button>

              <span class="p-datepicker-decade" *ngIf="currentView === 'year'">
                <ng-container *ngIf="!decadeTemplate">
                  {{ yearPickerValues()[0] }} - {{ yearPickerValues()[yearPickerValues().length - 1] }}
                </ng-container>
                <ng-container *ngTemplateOutlet="decadeTemplate; context: { $implicit: yearPickerValues }"></ng-container>
              </span>
            </div>

            <!-- Header: next arrow -->
            <button
              type="button"
              (keydown)="onContainerButtonKeydown($event)"
              class="p-datepicker-next p-link"
              [ngClass]="{
                'p-disabled': disabledNextAction()
              }"
              (click)="onNextButtonClick($event)"
              [style.display]="numberOfMonths === 1 ? 'inline-flex' : i === numberOfMonths - 1 ? 'inline-flex' : 'none'"
              pRipple
            >
              <span class="p-datepicker-next-icon pi pi-chevron-right"></span>
            </button>
          </div>
          <div class="p-datepicker-calendar-container" *ngIf="currentView === 'date'">
            <table aria-describedby="Calendar datepicker" class="p-datepicker-calendar">
              <thead>
                <tr>
                  <th scope="colWeek" *ngIf="showWeek" class="p-datepicker-weekheader p-disabled">
                    <span>{{ getTranslation('weekHeader') }}</span>
                  </th>
                  <th scope="col" *ngFor="let weekDay of weekDays; let begin = first; let end = last">
                    <span>{{ weekDay }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let week of month.dates; let j = index">
                  <td *ngIf="showWeek" class="p-datepicker-weeknumber">
                    <span class="p-disabled">
                      {{ month.weekNumbers[j] }}
                    </span>
                  </td>
                  <td
                    *ngFor="let date of week"
                    [ngClass]="{ 'p-datepicker-other-month': date.otherMonth, 'p-datepicker-today': date.today }"
                  >
                    <ng-container *ngIf="date.otherMonth ? showOtherMonths : true">
                      <span
                        [ngClass]="{ 'p-highlight': isSelected(date), 'p-disabled': !date.selectable }"
                        (click)="onDateSelect($event, date)"
                        draggable="false"
                        (keydown)="onDateCellKeydown($event, date, i)"
                        pRipple
                      >
                        <ng-container *ngIf="!dateTemplate">{{ date.day }}</ng-container>
                        <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: date }"></ng-container>
                      </span>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="p-monthpicker" *ngIf="currentView === 'month'">
        <span
          *ngFor="let m of monthPickerValues(); let i = index"
          (click)="onMonthSelect($event, i)"
          (keydown)="onMonthCellKeydown($event, i)"
          class="p-monthpicker-month"
          [ngClass]="{
            'p-highlight': isMonthSelected(i),
            'p-disabled': !isMonthValid(i)
          }"
          pRipple
        >
          {{ m }}
        </span>
      </div>

      <div class="p-yearpicker" *ngIf="currentView === 'year'">
        <span
          *ngFor="let y of yearPickerValues()"
          (click)="onYearSelect($event, y)"
          (keydown)="onYearCellKeydown($event, y)"
          class="p-yearpicker-year"
          [ngClass]="{
            'p-highlight': isYearSelected(y),
            'p-disabled': invalidMinYear(y) || invalidMaxYear(y)
          }"
          pRipple
        >
          {{ y }}
        </span>
      </div>
    </ng-container>
    <div class="p-timepicker" *ngIf="(showTime || timeOnly) && currentView === 'date'">
      <div class="p-hour-picker">
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="incrementHour($event)"
          (keydown.space)="incrementHour($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 0, 1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-up"></span>
        </button>
        <span> <ng-container *ngIf="currentHour < 10">0</ng-container>{{ currentHour }} </span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="decrementHour($event)"
          (keydown.space)="decrementHour($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 0, -1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-down"></span>
        </button>
      </div>
      <div class="p-separator">
        <span>{{ timeSeparator }}</span>
      </div>
      <div class="p-minute-picker">
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="incrementMinute($event)"
          (keydown.space)="incrementMinute($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 1, 1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-up"></span>
        </button>
        <span> <ng-container *ngIf="currentMinute < 10">0</ng-container>{{ currentMinute }} </span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="decrementMinute($event)"
          (keydown.space)="decrementMinute($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 1, -1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-down"></span>
        </button>
      </div>
      <div class="p-separator" *ngIf="showSeconds">
        <span>{{ timeSeparator }}</span>
      </div>
      <div class="p-second-picker" *ngIf="showSeconds">
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="incrementSecond($event)"
          (keydown.space)="incrementSecond($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 2, 1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-up"></span>
        </button>
        <span> <ng-container *ngIf="currentSecond < 10">0</ng-container>{{ currentSecond }} </span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="decrementSecond($event)"
          (keydown.space)="decrementSecond($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 2, -1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="pi pi-chevron-down"></span>
        </button>
      </div>
      <div class="p-ampm-picker" *ngIf="hourFormat === '12'">
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (click)="toggleAMPM($event)"
          (keydown.enter)="toggleAMPM($event)"
          pRipple
        >
          <span class="pi pi-chevron-up"></span>
        </button>
        <span>{{ pm ? 'PM' : 'AM' }}</span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (click)="toggleAMPM($event)"
          (keydown.enter)="toggleAMPM($event)"
          pRipple
        >
          <span class="pi pi-chevron-down"></span>
        </button>
      </div>
    </div>
    <div class="p-datepicker-buttonbar" *ngIf="showButtonBar">
      <button
        type="button"
        [label]="getTranslation('today')"
        (keydown)="onContainerButtonKeydown($event)"
        (click)="onTodayButtonClick($event)"
        pButton
        pRipple
        [ngClass]="[todayButtonStyleClass]"
      ></button>
      <button
        type="button"
        [label]="getTranslation('clear')"
        (keydown)="onContainerButtonKeydown($event)"
        (click)="onClearButtonClick($event)"
        pButton
        pRipple
        [ngClass]="[clearButtonStyleClass]"
      ></button>
    </div>
    <ng-content select="p-footer"></ng-content>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
</span>
